import { PropsWithChildren, forwardRef } from 'react';
import { useIntl } from 'react-intl';
import classNames from 'classnames';
import ArrowSq from '@alltrails/denali/icons/ArrowSq';
import IconButton from '@alltrails/denali/components/IconButton';
import Chevron from '@alltrails/denali/icons/Chevron';
import styles from './SidebarTitleArea.module.scss';

type SidebarTitleAreaProps = {
  canCollapse: boolean;
  collapsed: boolean;
  hideOverflow?: boolean;
  onBackRequest?: () => void;
  onCollapseRequest?: () => void;
  additionalButton?: React.ReactElement;
};

const SidebarTitleArea = forwardRef<HTMLDivElement, PropsWithChildren<SidebarTitleAreaProps>>(
  (
    { canCollapse, children, collapsed, onBackRequest, onCollapseRequest, hideOverflow, additionalButton }: PropsWithChildren<SidebarTitleAreaProps>,
    ref
  ) => {
    const intl = useIntl();
    return (
      <div className={styles.container} ref={ref}>
        <div className={styles.titleRow}>
          {onBackRequest ? (
            <IconButton
              icon={{ Component: ArrowSq, orientation: 'left' }}
              onClick={onBackRequest}
              size="sm"
              testId="sidebar-back-button"
              title={intl.formatMessage({ defaultMessage: 'Go back' })}
            />
          ) : (
            <div
              className={classNames(styles.title, {
                [styles.collapsed]: collapsed && !hideOverflow,
                [styles.hideOverflow]: hideOverflow && !collapsed
              })}
            >
              {children}
            </div>
          )}
          <div className={styles.buttonsContainer}>
            {additionalButton}
            {canCollapse && (
              <IconButton
                className={styles.collapseButton}
                icon={{ Component: Chevron, orientation: collapsed ? 'down' : 'up' }}
                onClick={onCollapseRequest}
                size="sm"
                testId="collapse-sidebar-button"
                title={collapsed ? intl.formatMessage({ defaultMessage: 'Expand panel' }) : intl.formatMessage({ defaultMessage: 'Collapse panel' })}
              />
            )}
          </div>
        </div>
        {onBackRequest && <div className={classNames(styles.title, { [styles.collapsed]: collapsed })}>{children}</div>}
      </div>
    );
  }
);

export default SidebarTitleArea;
